import React from 'react';
import { useTranslation } from 'react-i18next';
import { FORM_NAME, STREAM_ERROR } from './fields';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

export const StreamErrorHint = () => {
  const { t } = useTranslation();
  const { [STREAM_ERROR]: error } = useSelector(getFormValues(FORM_NAME));

  if (!error) {
    return null;
  }

  return error.kind === window.VideoCaptureAPI.PERMISSION_DENIED ? <div>{t('enable_devices')}</div> : null;
};
